<style>
  .check-icon {
    width: 26px;
    height: 26px;
    cursor: pointer;
  }
</style>

<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" class='check-icon'>
  <path d="M13 25.48A12.48 12.48 0 1013 .52a12.48 12.48 0 000 24.96zM13 2.6a10.4 10.4 0 110 20.8 10.4 10.4 0 010-20.8z" fill="#000"/>
  <path d="M11.22 16.86a1.04 1.04 0 00.74.3h.05a1.04 1.04 0 00.75-.37l5.2-6.24a1.04 1.04 0 00-1.6-1.34l-4.47 5.37-2.31-2.32a1.04 1.04 0 00-1.48 1.48l3.12 3.12z" fill="#000"/>
</svg>
